module.exports = __webpack_public_path__ + "img/scene3.e40c3928.svg";